import classNames from 'classnames';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { useAppSelector } from 'store/hooks';

export const FormLabel = ({
  children,
  required,
  className,
}: {
  children: React.ReactNode;
  required?: boolean;
  className?: string;
}) => {
  const { language } = useAppSelector(selectGlobalInfo);

  return (
    <label
      className={classNames('flex-shrink-0 text-right', className, {
        'required-field': required,
        'w-[120px]': language === 'zh_CN',
        'w-[145px]': language === 'ja',
        'w-[140px]': language === 'en',
      })}
    >
      {children}
    </label>
  );
};
